import React, { useState, useEffect } from 'react';
import { ICONS } from '../constants';

export const LOADING_STEPS = [
  'דוגם את ה-DNA של הערוץ...',
  'מנתח אלגוריתמים של ויראליות...',
  'רוקח קונספטים במעבדה...',
  'מזקק פסיכולוגיה של צבעים...',
  'מכין את התוצאות לתצוגה...',
];

interface GeneratingIdeasScreenProps {
  brandName?: string;
}

const GeneratingIdeasScreen: React.FC<GeneratingIdeasScreenProps> = ({ brandName }) => {
  const [loadingStep, setLoadingStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingStep((prev) =>
        prev < LOADING_STEPS.length - 1 ? prev + 1 : prev
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="relative mb-8">
        <div className="absolute inset-0 bg-click-red/20 blur-3xl rounded-full" />
        <div className="relative w-32 h-32">
          <div className="absolute inset-0 border-4 border-click-border rounded-full" />
          <div className="absolute inset-0 border-t-4 border-click-red rounded-full animate-spin" />
          <div className="absolute inset-2 border-r-4 border-click-cyan rounded-full animate-spin [animation-duration:1.5s] [animation-direction:reverse]" />
          <div className="absolute inset-0 flex items-center justify-center">
            <ICONS.FlaskConical className="w-12 h-12 text-white animate-pulse" />
          </div>
        </div>
      </div>
      <h2 className="text-3xl font-display font-bold text-white mb-2 transition-all duration-300 min-h-[40px]">
        {LOADING_STEPS[loadingStep]}
      </h2>
      <div className="flex gap-1 mt-4">
        {LOADING_STEPS.map((_, idx) => (
          <div
            key={idx}
            className={`h-1.5 w-8 rounded-full transition-all duration-500 ${
              idx <= loadingStep ? 'bg-click-red shadow-[0_0_10px_#FF003C]' : 'bg-click-border'
            }`}
          />
        ))}
      </div>
      {brandName && (
        <p className="text-gray-400 mt-6 text-sm">
          מזקק רעיונות עבור: <span className="text-click-cyan font-bold">{brandName}</span>
        </p>
      )}
    </div>
  );
};

export default GeneratingIdeasScreen;
